import axios, { resHandle } from "@/plugins/axios";

/**
 * @description 获取版本信息
 * @param vCom Vue组件
 */
const GetVersion = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/app/version").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 更新版本信息
 * @param vCom Vue组件
 */
const PostVersionData = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/app/version", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};



export { GetVersion, PostVersionData };
